module.exports = __webpack_public_path__ + "static/assets/4a0bf6dfba5b6bfaa0032016204f6ea9.png";